import { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../store/hooks";
import { useParams, useSearchParams } from "react-router-dom";
import { Box, Tab, Tabs } from "@mui/material";
import Tables from "../Tables/Tables";
import { CustomerDetailsOverViewStyles } from "./CustomerDetailsOverViewStyles";
import { MytasksDataProps } from "../CustomerDetailsList/CustomerDetailsList";
import { tasksTableHeadingsData } from "../../constants/tasksData";
import { RootState } from "../../store/store";
import { getCookie } from "../../utils/Utility";
import { GetAgentCustomerTasks } from "../MyTasks/MyTasksAction";
import { transformTasksData } from "../MyTasksTable/MyTasksTable";
import moment, { MomentInput } from "moment";

export interface OverviewPolicyData {
  policyType: string;
  policyDetails: {
    policyNumber: string;
    policyTypeNumber: string;
  };
  policyStatus: string;
  policyPremium: string | number;
  policyTerm: string;
  expiryDate: string;
  policyLastPayment: string;
}
interface CustomerDetailsOverviewDataProps {
  overviewPolicyData: OverviewPolicyData[];

  tasksData: MytasksDataProps[];
  overviewTableHeaders: string[];
}

const CustomerDetailsOverView: React.FC<CustomerDetailsOverviewDataProps> = ({
  overviewPolicyData,
  overviewTableHeaders,
}) => {
  const [value, setValue] = useState(0);
  const tabLabels = ["Policies", "Tasks"];
  const { data } = useAppSelector((state: RootState) => state.agentTasks);
  const { customerId } = useParams();
  const providerId = getCookie("id");
  const dispatch = useAppDispatch();
  const { editTaskResponse, addTaskResponse } = useAppSelector(
    (state) => state.addTask
  );
  const [searchParams] = useSearchParams();
  const taskId = searchParams.get("id");

  const compareAsc = (date1: MomentInput, date2: MomentInput) => {
    if (moment(date1).isBefore(date2)) return -1;
    if (moment(date1).isAfter(date2)) return 1;
    return 0;
  };

  const processedTasks = data
    .map((task) => ({
      ...task,
      // status: "Active",
    }))
    .sort((a, b) => {
      type PriorityKey = "high" | "medium" | "low" | "none";

      const priorityOrder: Record<PriorityKey, number> = {
        high: 1,
        medium: 2,
        low: 3,
        none: 4,
      };

      const priorityDiff =
        priorityOrder[a.priority?.toLowerCase() as PriorityKey] -
        priorityOrder[b.priority?.toLowerCase() as PriorityKey];
      if (priorityDiff !== 0) return priorityDiff;

      // If priorities are the same, compare dates
      return compareAsc(new Date(a.dueDate), new Date(b.dueDate));
    });

  useEffect(() => {
    dispatch(GetAgentCustomerTasks({ providerId, customerId }));
  }, [dispatch, editTaskResponse, addTaskResponse]);

  const tasks = transformTasksData(processedTasks);

  const tabComponents = [
    <Box sx={CustomerDetailsOverViewStyles.policyContainer}>
      <Tables
        headerData={overviewTableHeaders}
        data={overviewPolicyData}
        type="overviewTable"
      />
    </Box>,
    <Box sx={CustomerDetailsOverViewStyles.tasksContainer}>
      <Tables
        headerData={tasksTableHeadingsData}
        type="myTasksTable"
        data={tasks}
      />
    </Box>,
  ];

  return (
    <Box sx={CustomerDetailsOverViewStyles.container}>
      <Tabs
        onChange={(e, newValue) => setValue(newValue)}
        value={value}
        allowScrollButtonsMobile
      >
        {tabLabels.map((label, index) => (
          <Tab
            id={`${label}-tab`}
            data-test-id={`test-${label}`}
            aria-label={`${label}`}
            key={index}
            label={label}
            value={index}
            sx={{
              color: "#383D4E",
              fontFamily: "Playfair Display",
              fontStyle: "normal",
              fontWeight: 400,
              fontSize: "20px",
              textTransform: "none",
            }}
          />
        ))}
      </Tabs>

      {tabComponents[value]}
    </Box>
  );
};

export default CustomerDetailsOverView;
